import fp from 'lodash/fp'
import { combine, withEffect } from 'react-hooks-combine'
import { withRouter } from 'react-router-dom'

import LayoutComponent from './component'

export default combine({
  hocs: [withRouter],

  hooks: [
    withEffect((_store, { history }) => {
      const innerView = document.querySelector('#inner-view')
      // IE compatibility fixes
      const scrollInner = fp.hasIn('scrollTo', innerView)
        ? innerView.scrollTo.bind(innerView)
        : fp.noop

      return history.listen(() => {
        scrollInner(0, 0)
      })
    }, []),
  ],
})(LayoutComponent)
